import React, { useEffect, useState } from "react";
import modalStyles from "../styles/components/Modal.module.css";
import styles from "../styles/components/LoraPicker.module.css";
import useApi from "../hooks/useApi";

const LoraPicker = ({onClose, onSelect, onRemove, usedCharacters}) => {

  const [characters, setCharacters] = useState([]);
  const [loras, setLoras] = useState([]);
  const {get} = useApi();
	// const dispatch = useDispatch();

  useEffect(()=>{
    
    const getLoras = async () => {
      const response = await get(`/webapp/loras/`);
      setCharacters(response);
    }
    getLoras();
  }, []);

  const isUsed = (c) => {
    const used = usedCharacters.filter((character) => (character.key === c.id+c.name));
    return used.length > 0;
  }

  // console.log(usedCharacters)

  const handleSelect = (character) => {
    if(isUsed(character)) return;
    onSelect(character);
  }

  return (
    <div className={modalStyles.modalOverlay}>
      <div className={modalStyles.modalContent}>
        <div className={styles.text}>Pick a style</div>
        <div className={styles.loraGrid}>
          {characters.map((character)=>(
            <div key={character?.id} className={isUsed(character) ? styles.loraItemUsed : styles.loraItem} onClick={(e) => handleSelect(character)}>
              <img src={character?.thumbnail}/>
            </div>
          ))}
        </div>
    		<div className={modalStyles.modalButtons}>
          <button onClick={onClose} className={modalStyles.cancelButton}>
            cancel
          </button>
      	</div>
      </div>
    </div>
  );
};

export default LoraPicker;
